import { Handyman } from "@mui/icons-material";
import { Tooltip, Badge } from "@mui/material";
import { Maybe } from "../../types/types";

interface CorrectiveActionsDisplayProps {
    count: Maybe<number>
}

export default function CorrectiveActionsDisplay(props: CorrectiveActionsDisplayProps) {
    const { count } = props
    return (
        <Tooltip title="Tem Ações Corretivas">
            <Badge badgeContent={count} color="error" variant="dot">
                <Handyman fontSize="small" style={{ color: "#4a4a4a" }} />
            </Badge>
        </Tooltip>
    )

}
